export const DES_EDITOR_META = {
  name: {
    title: 'Name',
    errorMsg: 'Please enter a valid Name',
    required: true,
  },
};
